export const GOOGLE_ANALYTICS_ID = 'UA-7408552-31';
export const GOOGLE_TAG_MANAGER_ID = 'GTM-N6F9MBJR';
